export default __webpack_public_path__ + "static/media/img-0685-bosnia-half-face.fc222b64.png";